export interface DietaryOption {
  id: string
  label: string
  // Se é true, o campo de detalle pasa a ser obrigatorio
  requiresDetail: boolean
}

export const dietaryOptions: DietaryOption[] = [
  { id: 'vegetarian', label: 'Vexetariano/a', requiresDetail: false },
  { id: 'celiac', label: 'Celíaco/a', requiresDetail: false },
  { id: 'other', label: 'Outras', requiresDetail: true }
]

export const formatDietaryRestrictions = (ids: string[], notes: string): string => {
  const labels = ids.map(id => dietaryOptions.find(option => option.id === id)?.label ?? id)
  const detail = notes.trim()
  if (labels.length === 0 && detail === '') return 'Ningunha'
  return [labels.join(', '), detail].filter(part => part !== '').join(' - ')
}
